app.controller(
    'PlaceTranslationController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'PlaceService', 'SideBarService', 'HelperService', '$window', '$sce', '$translate', PlaceTranslationController]
);

function PlaceTranslationController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, PlaceService, SideBarService, HelperService, $window,$sce, $translate) {
    var vm = this;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    if ($stateParams.z) {
        $scope.vm.ParamZoneId = $stateParams.z;
    }
    else {
        $scope.vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = $scope.vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);
    
    $scope.vm = {};
    $scope.edit = {};

    $scope.vm.ActiveDescription = {};
    $scope.vm.ActiveDescriptionId = 0;
    $scope.vmDescriptionToTranslate = {};
    $scope.vm.SelectedDescriptionStatusItem = {};
    $scope.vm.PreviousDescriptionStatusItem = {};
    $scope.vm.ActiveDescriptionVm =
       {
           Clients: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
           QualificationList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
       };


    //Get Single     
    var promiseGetSingle = PlaceService.getPlace($stateParams.id, $scope.CurrentLang, $rootScope.LangForTranslationDestination, $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    promiseGetSingle.then(function (t) {
        var res = t.data;
        $scope.vm = res;
        $scope.vm.PlaceOrigin = angular.copy(res);
        $rootScope.placevm = res;
        $rootScope.PlaceList = res.PlaceList;
        $rootScope.CurrentObjectId = res.CurrentPlace.PlaceId;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.Place;
        $rootScope.Comments = res.CommentList;
        $rootScope.SideBar = res.SideBar;
        $rootScope.CurrentObjectStatus = res.CurrentPlaceStatus;
        $rootScope.SideBar.CurrentObjectStatus = res.CurrentPlaceStatus;
        $rootScope.Clients = res.ClientList;
        $rootScope.ClassificationList = res.ClassificationList;
        //$scope.ChangeZoneById(vm.ParamZoneId);

        if ($scope.vm.DescriptionList.length > 0) {
            $scope.vm.ActiveDescriptionId = 0;
            $scope.vm.ActiveDescription = $scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId];
            //load descriptionVm
            $scope.GetDescriptionVm();
            //load translation description
            $scope.GetDescriptionTranslated();
        }


    });


    $scope.PreviousDesc = function PreviousDesc() {
        if ($scope.vm.DescriptionList.length > 0 && $scope.vm.ActiveDescriptionId > 0) {
            $scope.vm.ActiveDescriptionId = $scope.vm.ActiveDescriptionId - 1;
            $scope.GetDescriptionVm();
            $scope.GetDescriptionTranslated();
        }
    }
    $scope.NextDesc = function NextDesc() {
        if ($scope.vm.DescriptionList.length > 0 && $scope.vm.ActiveDescriptionId < $scope.vm.DescriptionList.length - 1) {
            $scope.vm.ActiveDescriptionId = $scope.vm.ActiveDescriptionId + 1;
            $scope.GetDescriptionVm();
            $scope.GetDescriptionTranslated();
        }
    }
    $scope.GetDescriptionVm = function () {
        HelperService.GetDescriptionVm($scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId].DescriptionId, $scope.CurrentLang)
            .then(function (desc) {
                $scope.vm.ActiveDescriptionVm = desc;
            });
    }
    $scope.GetDescriptionTranslated = function GetDescriptionTranslated() {
        HelperService.GetDescriptionById($scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId].DescriptionId, $rootScope.LangForTranslationDestination)
                                .then(function (desc) {
                                    if (desc.success == false) {
                                        $scope.vmDescriptionToTranslate = angular.copy($scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId]);
                                        $scope.vmDescriptionToTranslate.LanguageCode = $rootScope.LangForTranslationDestination;
                                        $scope.vmDescriptionToTranslate.IsDefaultLang = false;
                                        $scope.vmDescriptionToTranslate.DescriptionTitle = '';
                                        $scope.vmDescriptionToTranslate.Stick = '';
                                        $scope.vmDescriptionToTranslate.Resume = '';
                                        $scope.vmDescriptionToTranslate.Description = '';
                                        $scope.vmDescriptionToTranslate.StatusTrad = $translate.instant("StatusId25");
                                        //init status
                                        $scope.vm.SelectedDescriptionStatusItem = $rootScope.StatusList4WorkflowDescriptionTranslationIdValue[0];
                                        $scope.vm.PreviousDescriptionStatusItem = angular.copy($scope.vm.SelectedDescriptionStatusItem);
                                        $scope.vm.NewDescription = true;

                                    }
                                    else {
                                        $scope.vmDescriptionToTranslate = desc;
                                        $scope.vm.SelectedDescriptionStatusItem = GetItemByFieldName($scope.vmDescriptionToTranslate.StatusId, 'id', $rootScope.StatusList4WorkflowDescriptionTranslationIdValue)[0];
                                        $scope.vm.PreviousDescriptionStatusItem = angular.copy($scope.vm.SelectedDescriptionStatusItem);
                                        $scope.vm.NewDescription = false;
                                    }
                                });
    };
    $scope.OpenInOtherLang = function OpenInOtherLang(lang) {
        $window.location.href = $rootScope.interfaceSubFolder +'/#!/traduction/place?id=' + $stateParams.id + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    $scope.UpdateDescriptionStatusId = function UpdateDescriptionStatusId() {
        if ($scope.vm.SelectedDescriptionStatusItem != undefined) {
            $scope.vmDescriptionToTranslate.StatusId = $scope.vm.SelectedDescriptionStatusItem.id;
        }
        else {
            $scope.vmDescriptionToTranslate.StatusId = 17;
        }
        if ($scope.vm.NewDescription) {
            HelperService.AddDescription($scope.vmDescriptionToTranslate)
            .then(function (data) {
                $scope.vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });
        }
        else {
            if ($scope.vm.SelectedDescriptionStatusItem != $scope.vm.PreviousDescriptionStatusItem) {
                $scope.vm.PreviousDescriptionStatusItem = $scope.vm.SelectedDescriptionStatusItem;
                HelperService.UpdateDescription($scope.vmDescriptionToTranslate)
                    .then(function (data) {

                    });
            }
        }
    }
    $scope.UpdateDescription = function UpdateDescription() {
        if ($scope.vm.SelectedDescriptionStatusItem != undefined) {
            $scope.vmDescriptionToTranslate.StatusId = $scope.vm.SelectedDescriptionStatusItem.id;
        }
        else {
            $scope.vmDescriptionToTranslate.StatusId = 17;
        }
        if ($scope.vm.NewDescription) {
            HelperService.AddDescription($scope.vmDescriptionToTranslate)
            .then(function (data) {
                $scope.vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });
        }
        else {
            HelperService.UpdateDescription($scope.vmDescriptionToTranslate)
                .then(function (data) {

                });
        }
    }

    $scope.UpdatePlace = function UpdatePlace() {

        PlaceService.UpdatePlace($scope.vm, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;

            } else {
                console.log("error: ");
            }
        });
    };

    //$scope.UpdateDescription = function UpdateDescription() {

    //    PlaceService.UpdateDescription($scope.vm, function (response) {

    //        if (response.success) {

    //            console.log("ok: ");
    //            $scope.vm = response;
    //        } else {
    //            console.log("error: ");
    //        }
    //    });
    //};

    $rootScope.TranslateDescription = function TranslateDescription(index) {

        PlaceService.TranslateDescription($scope.vm, $scope.CurrentLang, $rootScope.LangForTranslationDestination, index, function (response) {

            if (response.success) {

                console.log("ok: ");
            } else {
                console.log("error: ");
            }
        });
    };


    $scope.UpdateDescriptionStatus = function UpdateDescriptionStatus(status, index) {
        $scope.vm.DescriptionList[index].Description.StatusId = status;
        PlaceService.UpdateDescriptionStatus($scope.vm, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;
            } else {
                console.log("error: ");
            }
        });
    };


    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {

        SideBarService.UpdateObjectStatus(status, objectId, $rootScope.LangForTranslationDestination, 12, function (response) {

            if (response.success) {

                console.log("ok: ");

            } else {
                console.log("error: ");
            }
        });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment($scope.vm.SideBar.CommentEdit, $scope.vm.CurrentPlace.PlaceId, $scope.CurrentLang, 12);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };


    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        promiseAddComment = PlaceService.SaveDiffuseur($scope.vm.ClientList, $scope.vm.CurrentDisctrict.PlaceId, $scope.CurrentLang, 12);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        promiseAddComment = PlaceService.SaveAdressesAssociees($scope.vm.PlaceList, $scope.vm.CurrentDisctrict.PlaceId, $scope.CurrentLang, 12);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        promiseAddComment = PlaceService.SaveClassification($scope.vm.ClassificationList, $scope.vm.CurrentDisctrict.PlaceId, $scope.CurrentLang, 12);
    };


    // Fin  SideBar method


    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };

    $rootScope.refreshHistory = function refreshHistory() {
       
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Place", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);
                      
                  },
                function error(data) {
                });
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailSharePlacePracticalInfo', $translate.instant('emailSharePlacePracticalInfo').replaceAll('&amp;', '&'), $rootScope.placevm);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
};